import React from 'react'
import { useBulkCreateShiftsContextValue } from '../../context/BulkCreateShiftsProvider'
import { Footer } from '../Footer'
import { Box, Button, Flex } from '@workwhile/ui'
import { DoneTable } from './components/DoneTable'
import styles from './Done.module.css'

export const Done = () => {
  const {
    actions: { replace, reset },
  } = useBulkCreateShiftsContextValue()

  const handleStartOver = () => {
    reset()
    replace('import')
  }

  return (
    <Flex flexDirection="column" gap={3} height="100%" p={3}>
      <Flex
        flexDirection="column"
        gap={3}
        className={styles.container}
        height="100%"
      >
        <Box className={styles.content}>
          <DoneTable />
        </Box>
      </Flex>
      <Footer>
        <Button variant="secondary" onClick={handleStartOver}>
          Start Over
        </Button>
      </Footer>
    </Flex>
  )
}
